<div>
  <ng-container *ngIf="screenSize === 'desktop'">
    <frame-desktop></frame-desktop>
  </ng-container>
  <ng-container *ngIf="screenSize === 'tablet'">
    <frame-tablet></frame-tablet>
  </ng-container>
  <ng-container *ngIf="screenSize === 'mobile'">
    <frame-mobile></frame-mobile>
  </ng-container>
</div>
